package com.trevorwiebe.timesheet.admin.locations.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.Location
import com.trevorwiebe.timesheet.mileage.domain.model.LocationType

sealed class LocationsEvent {
    data object OnAddLocationClick : LocationsEvent()
    data class OnEditLocationClick(val location: Location) : LocationsEvent()
    data object OnDismissDialog : LocationsEvent()

    // Add/edit form (state lives in the ViewModel so the map picker and
    // async geocoding can write back into the in-progress form)
    data class OnFormNameChanged(val value: String) : LocationsEvent()
    data class OnFormCityChanged(val value: String) : LocationsEvent()
    data class OnFormStateChanged(val value: String) : LocationsEvent()
    data class OnFormTypeChanged(val value: LocationType) : LocationsEvent()
    data class OnFormAddressChanged(val value: String) : LocationsEvent()
    data object OnClearCoordinates : LocationsEvent()
    data object OnSaveLocation : LocationsEvent()

    // Geocoding / map pin picker
    data object OnGeocodeAddress : LocationsEvent()
    data object OnOpenMapPicker : LocationsEvent()
    data object OnCloseMapPicker : LocationsEvent()
    data class OnPinConfirmed(val latitude: Double, val longitude: Double) : LocationsEvent()
    data object OnDeleteLocation : LocationsEvent()
    data object OnRestoreLocation : LocationsEvent()
    data class OnFilterToggled(val filter: LocationFilter) : LocationsEvent()
    data class OnSearchQueryChanged(val value: String) : LocationsEvent()

    // Merge / multi-select
    data class OnEnterSelectionMode(val location: Location) : LocationsEvent()
    data object OnExitSelectionMode : LocationsEvent()
    data class OnToggleSelection(val location: Location) : LocationsEvent()
    data object OnMergeClick : LocationsEvent()
    data object OnDismissMergeDialog : LocationsEvent()
    data class OnConfirmMerge(val keeperId: String) : LocationsEvent()
}
